export default __webpack_public_path__ + "static/media/GT-Cinetype-Regular.03f14a23.ttf";